import * as React from "react";

const History = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="svg1"
    width="24"
    height="24"
    version="1.1"
    viewBox="0 0 6.35 6.35"
  >
    <g
      id="layer5"
      fill="none"
      stroke="#000"
      strokeDasharray="none"
      strokeLinecap="round"
      strokeLinejoin="miter"
      strokeOpacity="1"
      strokeWidth="0.4"
      display="inline"
    >
      <path
        id="path13"
        d="M4.859 4.859a2.38 2.38 0 0 1-2.875.378A2.38 2.38 0 0 1 .874 2.56 2.38 2.38 0 0 1 3.176.794a2.38 2.38 0 0 1 2.3 1.765"
        opacity="1"
      ></path>
      <path
        id="path14"
        d="m4.98 2.789.476.359a.15.15 171.995 0 0 .212-.03l.36-.477"
        opacity="1"
        transform="rotate(-15 3.37 3.06)"
      ></path>
      <path
        id="path15"
        d="M3.175 1.852V2.92a.51.51 116.565 0 1-.204.408l-.854.64"
        opacity="1"
      ></path>
    </g>
  </svg>
);

export default History;
